import { render, staticRenderFns } from "./MakeCol.vue?vue&type=template&id=420ef7f0&"
import script from "./MakeCol.vue?vue&type=script&lang=js&"
export * from "./MakeCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports